'use client'

import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { KitchenGuard } from '@/features/kitchen/KitchenGuard'
import { KitchenShell } from '@/shared/layouts/KitchenShell'
import { isSpa } from '@/shared/env'

export function KitchenAppLayout({ children }: { children?: ReactNode }) {
  const content = children ?? (isSpa ? <Outlet /> : null)
  return (
    <KitchenGuard>
      <KitchenShell>{content}</KitchenShell>
    </KitchenGuard>
  )
}
